export default "__VITE_ASSET__d5e51002__"